import { InsightContentSettingType } from 'components/insightContent/types'
import { InsightData } from 'schemas/action/InsightDataSchema'
import AnalysisFilter from 'types/analysisFilter'
import { toFilter } from 'utils/widgetUtil'
import { SocialWebPhotoConceptsWidget } from 'schemas/SocialWebPhotoConceptsWidgetSchema'
import { FilterTypeStrings } from 'enums/FilterType'
import { SearchFilterComposingStrategy } from 'utils/insightModal/strategy/searchFilterComposing/searchFilterComposingStrategy'
import { composeDetailSearchFilter } from 'utils/insightModal/composeDetailSearchFilter'
import { WidgetSettingComposingStrategy } from 'utils/insightModal/strategy/widgetSettingComposing/widgetSettingComposingStrategy'
import { composeDrillDownWidgetSetting } from 'utils/insightModal/composeDrillDownWidgetSetting'

export const convertToInsightContentSetting = (
  widgetSetting: SocialWebPhotoConceptsWidget,
  strategy: SearchFilterComposingStrategy,
  selection?: { insights?: Array<InsightData> }
) => {
  const { viewOption } = widgetSetting

  const insightContentSetting = {
    viewOption: viewOption!,
    emptyInsight: false,
    filter: toFilter(widgetSetting),
    topicInfos: widgetSetting.topicInfos!,
    drillDownTypes: [] as FilterTypeStrings[],
    drillDownFilter: {} as AnalysisFilter,
    selectedTopicInfo: widgetSetting.selectedTopic,
    topicId: widgetSetting.selectedTopic?.topicId,
    insights: selection ? selection?.insights : null
  } as InsightContentSettingType

  if (widgetSetting.precision) {
    insightContentSetting.precision = widgetSetting.precision
  }

  const insights = selection ? selection?.insights : null

  if (insights && insights.length > 0) {
    insightContentSetting.selectionName = insights?.[0]?.name
    // TODO: maybe handle selection names with array for multiple selections
    if (insights.length > 1) {
      if (insights.length === 2) {
        insightContentSetting.selectionSecondName = insights?.[0]?.name
      }
    }

    insightContentSetting.selectionFilter = composeDetailSearchFilter(
      strategy,
      widgetSetting,
      insights
    )
  }
  return insightContentSetting
}

export const addSelectionFilterToWidgetSetting = (
  widgetSetting: SocialWebPhotoConceptsWidget,
  strategy?: WidgetSettingComposingStrategy,
  selection?: { insights?: Array<InsightData> }
) => {
  if (strategy && selection && widgetSetting && typeof widgetSetting === 'object') {
    return composeDrillDownWidgetSetting(strategy, widgetSetting, selection.insights!)
  }
  return widgetSetting
}
